import React from "react";

const ViewSite = ({ currentItem, onBack }) => {
    return (
        <div className="card fade-in">
            <div className="card-head">
                <button onClick={onBack} className="mdl-button mdl-button--icon margin-left-20">
                    <i className="material-icons text-primary">arrow_back</i>
                </button>
            </div>
            <div className="card-body">
                <div class="text-center m-b-20">
                    <img className="img-circle user-img-circle" src={currentItem.logo || `https://dummyimage.com/100x100&text=${currentItem.name}`} alt={currentItem.name} />
                </div>
                <div className="height-9">
                    <ul className="list-group list-group-unbordered">
                        <li className="list-group-item">
                            <b className="col-lg-4">Name:</b>
                            <div className="col-lg-7 pull-right">{currentItem.name}</div>
                        </li>
                        <li className="list-group-item">
                            <b className="col-lg-4">E-mail:</b>
                            <div className="col-lg-7 pull-right">{currentItem.email}</div>
                        </li>
                        <li className="list-group-item">
                            <b className="col-lg-4">Telephone: </b>
                            <div className="col-lg-7 pull-right">{currentItem.tel}</div>
                        </li>
                        <li className="list-group-item">
                            <b className="col-lg-4">Website: </b>
                            <div className="col-lg-7 pull-right">
                                {currentItem.website ? (
                                    <a className="text-success" target="_blank" rel="noopener noreferrer" href={`http://${currentItem.website}`}>
                                        {currentItem.website}
                                    </a>
                                ) : (
                                    <strong className="text-danger">No Website Found!</strong>
                                )}
                            </div>
                        </li>
                        <li className="list-group-item">
                            <b className="col-lg-4">Site Type: </b>
                            <div className="col-lg-7 pull-right">
                                <strong>{currentItem.type.name}</strong>
                            </div>
                        </li>
                        <li className="list-group-item">
                            <b className="col-lg-3">Address: </b>
                            <div className="col-lg-7 pull-right">{currentItem.address ? currentItem.address : <strong className="text-danger">No Address Found!</strong>}</div>
                        </li>
                        <li className="list-group-item">
                            <b className="col-lg-4">Date of Joining: </b>
                            <div className="col-lg-7 pull-right">
                                {Intl.DateTimeFormat("en-GB", {
                                    weekday: "long",
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                }).format(new Date(parseInt(currentItem.created_at)))}
                            </div>
                        </li>
                    </ul>
                    <div className="row list-separated profile-stat"></div>
                    <div className="text-center">
                        <button type="button" className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-circle margin-right-10 btn-default" onClick={onBack}>
                            <i className="material-icons text-primary">arrow_back</i> Back
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewSite;
